import { useEffect } from 'react';

/**
 * SocialBar - Injecte le script social sur toutes les pages
 */
// SocialBar désactivée : script supprimé pour désactivation totale de la pub sociale
// const SOCIALBAR_SRC = '';

// SocialBar désactivée : code supprimé pour désactivation totale de la pub sociale
export const SocialBar = () => null;

export default SocialBar;
